module.exports = __webpack_public_path__ + "img/57.752f0c5f.png";